import React from "react";
import { Link } from "react-router-dom";
import { AutoTranslated } from "./KathaAutoTranslation";

/** Real links let crawlers (and users without JS) follow all catalog pages. */
export default function KathaPagination({ current, total, createHref, label = "पृष्ठ" }) {

  if (total <= 1) return null;
  const pageLink = (page, content, className = "") => (
    <Link
      key={page + "-" + content}
      to={createHref(page)}
      aria-label={(`${label} ${page}`)}
      aria-current={current === page ? "page" : undefined}
      className={`katha-page-link ${current === page ? "is-active" : ""} ${className}`}
    >
      {typeof content === "string" ? (content) : content}
    </Link>
  );
  return (
    <AutoTranslated>
    <nav aria-label={(`${label} नेविगेशन`)} className="katha-pagination">
      {current > 1 ? pageLink(current - 1, "← पिछला", "katha-page-prev") : <span className="katha-page-disabled">{("← पिछला")}</span>}
      {Array.from({ length: total }, (_, i) => pageLink(i + 1, i + 1))}
      {current < total ? pageLink(current + 1, "अगला →", "katha-page-next") : <span className="katha-page-disabled">{("अगला →")}</span>}
    </nav>
    </AutoTranslated>
  );
}
